module.exports = "https://s3-ap-southeast-2.amazonaws.com/slik-fonts/ufc0001/img/arrow-right.b2905ebf.svg";